module.exports = __webpack_public_path__ + "img/book_guy.1871823.webp";